import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { FC } from "react";
import { Backdrop } from "./Layout/Backdrop";
import SubmitButton from "./SubmitButton";

type Props = {
  title: string;
  message: string;
  onDismiss: () => void;
  open: boolean;
  dismissTitle: string;
};

const Wrapper = styled(motion.div)(() => ({
  backgroundColor: "#fff",
  width: "clamp(300px, 50%, 600px)",
  padding: "1rem",
  borderRadius: 12,
}));

const Footer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  marginTop: 10,
}));

const Alert: FC<Props> = (props) => {
  return (
    <AnimatePresence>
      {props.open && (
        <Backdrop
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <Wrapper
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
          >
            <h4>{props.title}</h4>
            <p>{props.message}</p>
            <Footer>
              <SubmitButton
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                style={{ margin: 0 }}
                type="button"
                onClick={props.onDismiss}
              >
                {props.dismissTitle}
              </SubmitButton>
            </Footer>
          </Wrapper>
        </Backdrop>
      )}
    </AnimatePresence>
  );
};

export default Alert;
